import React, { FC, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Copyright from '../../components/Copyright';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import LoadingButton from '../../components/buttons/LoadingButton';
import { useHistory } from 'react-router-dom';
import * as auth from '../../api/auth';
import { TokenStorage } from '../../api/auth/TokenStorage';
import jwt from 'jsonwebtoken';
import { InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InfoHelpDialog from '../../components/dialogs/InfoDialog';



const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: '100vh',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    }
}));

type FormValues = {
    password: string;
    confirmPassword: string;
}

const ChangePassword: FC = () => {
    const classes = useStyles();
    const { register, handleSubmit, errors } = useForm<FormValues>();
    const [error, setError] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [pending, setPending] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formValidated, setFormValidated] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [goToLogin, setGoToLogin] = useState(false);
    const [infoOpen, setInfoOpen] = useState(false);
    const history = useHistory();
    const [open, setOpen] = useState(!!process.env.REACT_APP_TEST_BUILD);

    const queryParams = new URLSearchParams(window.location.search)
    const paramResetToken = queryParams.get('token');
    const resetToken = TokenStorage.getResetPassToken();

    useEffect(() => {
        if (formValidated && isSubmit) {
            OnSubmit();
        }
    }, [formValidated])

    useEffect(() => {
        if (goToLogin) {
            history.push("/login");
        }
    }, [goToLogin])

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    const handleChange = (e: any) => {
        if (e.target.name === "password") {
            setPassword(e.target.value);
        }
        if (e.target.name === "confirmPassword") {
            setConfirmPassword(e.target.value);
        }
    };

    const ValidateForm = () => {
        if (password && confirmPassword) {
            if (password.length >= 3) {
                if (password == confirmPassword) {
                    setFormValidated(true);
                    //Passwords dont match
                } else {
                    setError('Sørg for at den indtastede kode er ens i begge felter');
                    setFormValidated(false);
                }

                //Password is too short
            } else {
                setError('Kodeordet skal minimum være 3 cifre');
                setFormValidated(false);
            }

            //Not all fields are filled
        } else {
            setError('Ikke alle felter er udfyldt');
            setFormValidated(false);
        }
    }

    const submitHandler = async (e: any) => {
        e.preventDefault();
        setIsSubmit(true);
        ValidateForm();
    }

    const handleGoToLogin = () => {
        setGoToLogin(true);
    };

    const handleCloseInfo = () => {
        setInfoOpen(false)
        handleGoToLogin();
    };

    const OnSubmit = () => {
        setPending(true);
        try {
            if (resetToken) {
                const decodedToken: any = jwt.decode(resetToken as any);
                const exp = decodedToken.exp * 1000;
                const tokenEmail = decodedToken.email;
                setEmail(tokenEmail)
                const now = new Date();
                if (resetToken == paramResetToken && now.getTime() < exp) {
                    passwordRequest(tokenEmail, password);
                }

                //Local storage token doesnt match with token from url, or the token is expired
                else {
                    setError('Tiden er udløbet - anmod om at nulstille kodeordet igen');
                }
            } else {
                setError('Tiden er udløbet - anmod om at nulstille kodeordet igen');
            }
        }
        catch (e) {
            setError('Der skete en fejl - prøv igen senere');
            setPending(false);
            setIsSubmit(false);
            setFormValidated(false);

        }
        setPending(false);
        setIsSubmit(false);
        setFormValidated(false);
    }

    const passwordRequest = async (email: string, password: string) => {
        const pwChanged = await auth.changePassword(email, password).catch(_ => { });
        if (!pwChanged) {
            setError('Kunne ikke ændre kodeordet - prøv igen.');
            setPending(false);
            setIsSubmit(false);
            setFormValidated(false);

        }
        else {
            setInfoOpen(true);
        }

    };

    const handleClose = () => {
        setError('');
    };


    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid container justify="center" alignItems="center" item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} className={classes.container}>
                    <div className={classes.paper}>
                        <Typography component="h1" variant="h5">
                            Opret nyt kodeord
                        </Typography>
                        <form className={classes.form} noValidate onSubmit={submitHandler}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Nye kodeord"
                                type={showPassword ? "text" : "password"}
                                id="password"
                                autoComplete="current-password"
                                onChange={handleChange}
                                inputRef={register({
                                    required: true,
                                })}
                                error={errors.password ? true : false}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />

                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="confirmPassword"
                                label="Bekræft kodeord"
                                type={showPassword ? "text" : "password"}
                                id="confirmPassword"
                                autoComplete="current-password"
                                onChange={handleChange}
                                inputRef={register({
                                    required: true,
                                })}
                                error={errors.password ? true : false}
                            />
                            <LoadingButton pending={pending} text={"Opdater Kodeord"} update={() => { }} />
                            <Grid container>
                                <Grid item xs style={{ textAlign: 'left' }}>
                                    <Link onClick={handleGoToLogin} variant="body2" style={{ cursor: 'pointer' }}>
                                        Gå tilbage til login?
                                    </Link>
                                </Grid>
                            </Grid>
                            <Box mt={5}>
                                <Copyright />
                            </Box>
                        </form>
                    </div>
                </Grid>
            </Grid>
            <Dialog
                open={(!!error)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"FEJL - Kunne ikke ændre kodeord"}</DialogTitle>
                <DialogContent>
                    {error &&
                        <DialogContentText id="alert-dialog-description">
                            <Error />
                            {((error) ? error : "")}
                        </DialogContentText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Luk
                    </Button>
                </DialogActions>
            </Dialog>
            <InfoHelpDialog
                title={`Kodeord Ændret`}
                text={`Dit kodeord er blevet ændret.
                \nDu vil nu blive omdirigeret til login siden.`}
                open={infoOpen}
                onClose={() => handleCloseInfo()}
            />
        </Grid>
    );
}

export default ChangePassword;